import type { ImportBinding, ImportDocumentSnapshot } from "@magic-md/core";

interface ImportExecutionDocumentLike {
    document?: ImportDocumentSnapshot;
}

export function collectImportDocuments(
    imports: readonly ImportBinding[] | null | undefined,
    importExecutions: ReadonlyMap<string, ImportExecutionDocumentLike> = new Map(),
): Map<string, ImportDocumentSnapshot> {
    const docs = new Map<string, ImportDocumentSnapshot>();
    const documentImportNamespaces = new Set(
        (imports ?? [])
            .filter((imp) => imp.document)
            .map((imp) => imp.namespace),
    );

    for (const imp of imports ?? []) {
        if (imp.document && imp.output?.document) {
            docs.set(imp.namespace, imp.output.document);
        }
    }

    for (const [namespace, entry] of importExecutions) {
        if (documentImportNamespaces.has(namespace) && entry.document) {
            docs.set(namespace, entry.document);
        }
    }

    return docs;
}
